/*
* Copyright (C) Regione Lombardia
*/
import { Component } from '@angular/core';

@Component({
    selector: 'app-pages-cms-privacy',
    templateUrl: './privacy.component.html',
    styles: ['tr,th,td { border: 1px solid #dddddd; text-align: left; padding: 8px !important; }']

})
export class PagesCmsPrivacyComponent { }
